<template>
  <div class="home page">
    <header>
        <h1>Unither Packaging</h1>
        <router-link to="/orders">Work Orders</router-link>
    </header>
    <section>
      
    </section>
    
  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'home',
  mounted: function(){

  },
  components: {

  },
  data: function(){
    return {
     
    }
  }
}
</script>

<style scoped>

</style>
